import type { ReactNode } from 'react';
import { RadioChangeEvent } from 'antd';
import { useTranslation } from 'react-i18next';
import { AntdForm, AntdRadio, COLOR_BASE_300, useTheme } from '@ui';

type OptionalLocationProps = {
  className?: string;
  falseDataTestId?: string;
  isActive: boolean;
  label: ReactNode;
  name: string;
  onChange: (e: RadioChangeEvent) => void;
  trueDataTestId?: string;
};

export const BooleanRadio = ({
  isActive,
  name,
  label,
  onChange,
  className,
  trueDataTestId,
  falseDataTestId,
}: OptionalLocationProps) => {
  const { t } = useTranslation();
  const { textColorDark } = useTheme();

  return (
    <AntdForm.Item name={name} label={label} className={className}>
      <AntdRadio.Group onChange={onChange} className="flex flex-nowrap gap-2">
        <div
          className="px-3 py-2 rounded-[100px] border-solid"
          style={{ borderColor: isActive ? textColorDark : COLOR_BASE_300 }}
        >
          <AntdRadio value={true} checked={true} className="m-0" data-testid={trueDataTestId}>
            {t('common.yes')}
          </AntdRadio>
        </div>
        <div
          className="px-3 py-2 rounded-[100px] border-solid"
          style={{ borderColor: isActive ? COLOR_BASE_300 : textColorDark }}
        >
          <AntdRadio
            value={false}
            checked={!isActive}
            className="m-0"
            data-testid={falseDataTestId}
          >
            {t('common.no')}
          </AntdRadio>
        </div>
      </AntdRadio.Group>
    </AntdForm.Item>
  );
};
